import script from "./LayoutCommon.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutCommon.vue?vue&type=script&setup=true&lang=js"

import "./LayoutCommon.vue?vue&type=style&index=0&id=61e30d91&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e30d91"]])

export default __exports__